import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, Inject } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { CollectionNestedOption, NestedOptionHost, NestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { DOCUMENT } from '@angular/common';

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
let DxiTextBoxButtonComponent = /*#__PURE__*/(() => {
  class DxiTextBoxButtonComponent extends CollectionNestedOption {
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get _optionPath() {
      return 'buttons';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiTextBoxButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTextBoxButtonComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiTextBoxButtonComponent,
      selectors: [["dxi-text-box-button"]],
      inputs: {
        location: "location",
        name: "name",
        options: "options"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiTextBoxButtonComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiTextBoxButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiTextBoxButtonModule = /*#__PURE__*/(() => {
  class DxiTextBoxButtonModule {
    /** @nocollapse */static ɵfac = function DxiTextBoxButtonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTextBoxButtonModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiTextBoxButtonModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiTextBoxButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTextBoxOptionsComponent = /*#__PURE__*/(() => {
  class DxoTextBoxOptionsComponent extends NestedOption {
    renderer;
    document;
    element;
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get onClick() {
      return this._getOption('onClick');
    }
    set onClick(value) {
      this._setOption('onClick', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get stylingMode() {
      return this._getOption('stylingMode');
    }
    set stylingMode(value) {
      this._setOption('stylingMode', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useSubmitBehavior() {
      return this._getOption('useSubmitBehavior');
    }
    set useSubmitBehavior(value) {
      this._setOption('useSubmitBehavior', value);
    }
    get validationGroup() {
      return this._getOption('validationGroup');
    }
    set validationGroup(value) {
      this._setOption('validationGroup', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'options';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTextBoxOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTextBoxOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTextBoxOptionsComponent,
      selectors: [["dxo-text-box-options"]],
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        disabled: "disabled",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        icon: "icon",
        onClick: "onClick",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        rtlEnabled: "rtlEnabled",
        stylingMode: "stylingMode",
        tabIndex: "tabIndex",
        template: "template",
        text: "text",
        type: "type",
        useSubmitBehavior: "useSubmitBehavior",
        validationGroup: "validationGroup",
        visible: "visible",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoTextBoxOptionsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoTextBoxOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTextBoxOptionsModule = /*#__PURE__*/(() => {
  class DxoTextBoxOptionsModule {
    /** @nocollapse */static ɵfac = function DxoTextBoxOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTextBoxOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTextBoxOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTextBoxOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiTextBoxButtonComponent, DxiTextBoxButtonModule, DxoTextBoxOptionsComponent, DxoTextBoxOptionsModule };
